import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

/**
 * Read a single feature flag from Redux.
 *
 * Render safety: the selector returns a boolean primitive.
 * React-Redux uses strict equality (===) — a component using this hook
 * re-renders ONLY when the value of its specific flag changes, not when
 * any other flag in the map is updated.
 */
export const useFeatureFlag = (
  key: string,
  defaultValue: boolean | string = false,
): boolean | string =>
  useSelector(
    (state: RootState) => state.featureFlags.flags[key] ?? defaultValue,
  );
